import { render, staticRenderFns } from "./DashboardCardStats.vue?vue&type=template&id=814c9124"
import script from "./DashboardCardStats.vue?vue&type=script&lang=ts"
export * from "./DashboardCardStats.vue?vue&type=script&lang=ts"
import style0 from "./DashboardCardStats.vue?vue&type=style&index=0&id=814c9124&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports